<script setup lang="ts">
// Formkit schema: https://formkit.com/api-reference/formkit-inputs#formkitschemaextendablesection
import type { UmbracoFormField } from 'types/blocks';

const { getDefaultFormField } = useForm();

defineProps<{
  field: UmbracoFormField;
}>();
</script>

<template>
  <FormKit
    :value="field.settings.defaultValue"
    v-bind="getDefaultFormField(field)"
    type="select"
    :validation-messages="{
      required: field.requiredErrorMessage || $t('FormMessages.General.Required'),
    }"
    :validation="field.required ? 'required' : ''"
    select-icon="down"
    selected-icon="right"
    :multiple="field.settings.allowMultipleSelections !== null && field.settings.allowMultipleSelections === 'True'"
    open-on-focus
  />
</template>
